// extracted by mini-css-extract-plugin
export var labelWrapper = "_gj-0";